/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RosettaAccountBalanceResponseCoinIdentifier,
    RosettaAccountBalanceResponseCoinIdentifierFromJSON,
    RosettaAccountBalanceResponseCoinIdentifierFromJSONTyped,
    RosettaAccountBalanceResponseCoinIdentifierToJSON,
} from './';

/**
 * CoinChange is used to represent a change in state of a some coin identified by a coin_identifier. This object is part of the Operation model and must be populated for UTXO-based blockchains. Coincidentally, this abstraction of UTXOs allows for supporting both account-based transfers and UTXO-based transfers on the same blockchain (when a transfer is account-based, don't populate this model).
 * @export
 * @interface RosettaCoinChange
 */
export interface RosettaCoinChange {
    /**
     * 
     * @type {RosettaAccountBalanceResponseCoinIdentifier}
     * @memberof RosettaCoinChange
     */
    coin_identifier: RosettaAccountBalanceResponseCoinIdentifier;
    /**
     * CoinActions are different state changes that a Coin can undergo. When a Coin is created, it is coin_created. When a Coin is spent, it is coin_spent. It is assumed that a single Coin cannot be created or spent more than once.
     * @type {string}
     * @memberof RosettaCoinChange
     */
    coin_action: RosettaCoinChangeCoinActionEnum;
}

/**
* @export
* @enum {string}
*/
export enum RosettaCoinChangeCoinActionEnum {
    created = 'coin_created',
    spent = 'coin_spent'
}

export function RosettaCoinChangeFromJSON(json: any): RosettaCoinChange {
    return RosettaCoinChangeFromJSONTyped(json, false);
}

export function RosettaCoinChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosettaCoinChange {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'coin_identifier': RosettaAccountBalanceResponseCoinIdentifierFromJSON(json['coin_identifier']),
        'coin_action': json['coin_action'],
    };
}

export function RosettaCoinChangeToJSON(value?: RosettaCoinChange | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'coin_identifier': RosettaAccountBalanceResponseCoinIdentifierToJSON(value.coin_identifier),
        'coin_action': value.coin_action,
    };
}

